import { Illu } from "./Illustrations";

/** Three graphic modules instead of pure text cards. Texts unchanged. */
export const Positioning = ({ texts }) => {
  const modules = [
    { key: texts.illu_pos_1, label: "Ikonische Figur", fallback: "head" },
    { key: texts.illu_pos_2, label: "Geometrischer Bruch", fallback: "tower" },
    { key: texts.illu_pos_3, label: "Erzählerische Welt", fallback: "portal" },
  ];

  return (
    <section
      data-testid="positioning-section"
      className="relative overflow-hidden border-b border-obsidian-line bg-ink ap-section"
    >
      <div className="pointer-events-none absolute inset-0 ap-grid-bg-dark" aria-hidden="true" />
      <div className="ap-container relative grid gap-10 lg:grid-cols-[0.86fr_1.14fr] lg:gap-16">
        <div>
          <p className="ap-stamp mb-5">AP · POSITION</p>
          <h2 className="ap-h2 text-paper">{texts.positioning_h2}</h2>
          <span className="mt-8 block h-px w-24 bg-signal" aria-hidden="true" />
        </div>

        <div className="flex flex-col justify-center">
          <p className="max-w-2xl text-base leading-relaxed text-paper/80 sm:text-lg">
            {texts.positioning_body}
          </p>

          <ul className="mt-10 grid gap-5 sm:grid-cols-3">
            {modules.map((m, i) => (
              <li
                key={m.label}
                data-testid={`positioning-module-${i}`}
                className={`relative border-t border-obsidian-line pt-5 ${i === 1 ? "sm:-mt-6" : ""} ${
                  i === 2 ? "sm:mt-4" : ""
                }`}
              >
                <div className="ap-illu relative h-24 w-24 opacity-90 invert hue-rotate-180 sm:h-28 sm:w-28">
                  <Illu name={m.key} fallback={m.fallback} className="h-full w-full" />
                </div>
                <span className="ap-stamp absolute right-1 top-4 text-signal">0{i + 1}</span>
                <p className="mt-3 font-display text-base font-bold uppercase tracking-wide text-paper">
                  {m.label}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
